import { render, staticRenderFns } from "./OperationsTotals.vue?vue&type=template&id=726afa76&scoped=true"
import script from "./OperationsTotals.vue?vue&type=script&lang=js"
export * from "./OperationsTotals.vue?vue&type=script&lang=js"
import style0 from "./OperationsTotals.vue?vue&type=style&index=0&id=726afa76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726afa76",
  null
  
)

export default component.exports